import React from 'react';
import { ApIcon } from '@alixpartners/ui-components';
import {
  ProgressBarSection,
  ProgressBarTextWrapper,
  IconWrapper,
} from './NotificationBar.styles';

interface INotificationBar {}

const NotificationBar = ({
  error,
  failMessage = '',
  successMessage = '',
  onClose,
}: {
  error?: boolean;
  failMessage?: string;
  onClose?: () => void;
  successMessage?: string;
}) => (
  <ProgressBarSection error={error}>
    <ProgressBarTextWrapper>
      {!error ? successMessage : failMessage || 'Something went wrong'}
    </ProgressBarTextWrapper>
    {onClose && (
      <IconWrapper onClick={onClose}>
        <ApIcon iconName="baseline_close" iconSize="24px" iconColor="#cde7c7" />
      </IconWrapper>
    )}
  </ProgressBarSection>
);

export default NotificationBar;
